export const getViewHeight = () => {
    return document.body.clientHeight || document.documentElement.clientHeight || window.innerHeight;
};

export const getViewWidth = () => {
    return document.body.clientWidth || document.documentElement.clientWidth || window.innerWidth;
};